import colorMod from 'color';

export default ({ color, fontSize, typography }) => ({
  filterRankContainer: {
    fontSize: fontSize.small,
    marginBottom: 35,
    marginLeft: 20,
    marginRight: 20,
    marginTop: 35,
  },
  linkBar: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  linkBtn: {
    borderColor: 'none',
    border: 'none',
    height: '40px!important',
    background: 'none',
    outline: 'none',
    display: 'inline',
    color: color.link,
    fontFamily: typography.buttonText,
    fontSize: fontSize.buttonText,
    textDecoration: 'none',
    '&:focus': {
      outline: 'none',
      boxShadow: 'none',
    },
    '&:hover,&:active': {
      color: color.linkHover,
    },
  },
  rankFieldsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  searchBar: {
    borderBottom: `1px solid ${color.borderColor}`,
    marginBottom: 10,
  },
  textInput: {
    width: 80,
    height: 40,
    color: color.bodyText,
    display: 'inline-block',
    fontFamily: typography.bodyText,
    fontSize: fontSize.buttonText,
  },
  invalidTextInput: {
    '& input': {
      borderColor: color.borderColorError,
    },
    '&:focus div': {
      boxShadow: `0 0 0 1px #ffffff, 0 0 0 2px ${color.borderColorError}`,
    },
    '& input:focus + div': {
      boxShadow: `0 0 0 1px #ffffff, 0 0 0 2px ${color.borderColorError}`,
    },
    '& div': {
      borderColor: color.borderColorError,
    },
  },
  rankSizeBtn: {
    color: color.primaryButtonBackground,
    background: color.primaryButtonText,
    marginLeft: 10,
    height: 40,
    borderRadius: 3,
    width: 42,
    fontFamily: typography.buttonText,
    fontSize: fontSize.buttonText,
    border: '1px solid',
    borderColor: color.primaryButtonBackground,
    '&:hover': {
      background: `${colorMod(color.primaryButtonBackground).alpha(0.05).string()} !important`,
    },
    '&:focus': {
      background: `${colorMod(color.primaryButtonBackground).alpha(0.05).string()} !important`,
      outline: 'none',
    },
    '&:active': {
      background: `${colorMod(color.primaryButtonBackground).alpha(0.05).string()} !important`,
      borderStyle: 'solid',
    },
    '&:disabled': {
      backgroundColor: '#D1D1D1',
      color: '#464646',
      border: 'none',
    },
  },
  helperMessage: {
    color: color.smallText,
    fontFamily: typography.smallText,
    fontSize: fontSize.smallText,
  },
  label: {
    marginBottom: 5,
    color: color.bodyText,
    fontFamily: typography.bodyText,
    fontSize: fontSize.bodyText,
    fontWeight: 'bold',
  },
  errorMessage: {
    color: 'red',
    fontSize: fontSize.small,
  },
  filterFooter: {
    paddingLeft: 20,
    paddingTop: 20,
    borderTop: `1px solid ${color.borderColor}`,
  },
  rankField: {
    width: 80,
  },
  rankSizeSection: {
    alignItems: 'center',
    display: 'flex',
  },
  rankTypeSelectContainer: {
    marginTop: '0 !important',
    width: 160,
  },
});
